export const TEAM = [
  {
    id: "laetitia",
    name: "Laetitia",
    role: "La Vision & La Coach Inspirée",
    tagline: "Ok Seigneur, j'ai capté… j'y vais !",
    short:
      "Fondatrice de Jesus Talk. Elle a reçu la vision et emmène les auditeurs aux pieds du Père avec une approche narrative, rythmée et incarnée.",
    long:
      "Laetitia est le cœur battant de Jesus Talk. C'est à elle que Dieu a révélé la vision de ce média chrétien : un espace pour développer sa vie spirituelle et sa relation avec Jésus, à travers des podcasts et des supports de communication accessibles à tous. Sa voix, douce et déterminée, guide, console et invite à faire un pas de plus.",
    color: "from-[#C5D3DC] to-[#7B98A8]",
    image: "/assets/team/laetitia.jpg",
  },
  {
    id: "belver",
    name: "Prophète Belver",
    role: "Le Feu & Le Ministère Prophétique",
    tagline: "Il est temps de te réveiller.",
    short:
      "Voix de Wake Up It's Time. Prophète, mari et père — il porte l'onction de la Parole pour secouer les consciences endormies.",
    long:
      "Prophète Belver, mari de Laetitia et père, porte l'appel du réveil au sein de Jesus Talk. Son ministère prophétique le conduit d'église en église pour apporter la délivrance, fortifier les assemblées et rallumer le feu là où il s'était éteint. Sa voix est celle de Wake Up It's Time.",
    color: "from-[#4A6D82] to-[#2E4959]",
    image: "/assets/team/belver.jpg",
  },
  {
    id: "nathalie",
    name: "Nathalie",
    role: "Le Partage & La Prof",
    tagline: "Ancrer chaque parole dans le texte.",
    short:
      "Voix de Deep Talks. Théologiquement affûtée, elle plonge les auditeurs dans les profondeurs de la Parole avec justesse et ancrage textuel.",
    long:
      "Nathalie est la voix de Deep Talks. Passionnée d'exégèse, elle rend la profondeur biblique accessible et vivante. Son approche pédagogique donne des racines solides à la foi vécue, en ramenant toujours à la Parole écrite.",
    color: "from-[#C99A5B] to-[#7A5B2E]",
    image: "/assets/team/nathalie.jpg",
  },
];
